// extracted by mini-css-extract-plugin
module.exports = {"container":"Notification_container__1Tu7D"};